import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { StackingContext } from '@picsart/design-system/foundation/stackingContext';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  {
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: [Spacings.s8, Spacings.s16],
      backgroundColor: BackgroundColors.base,
      position: 'sticky',
      top: 0,
      zIndex: StackingContext.layout,
      transform: 'translateZ(0)',
      backfaceVisibility: 'hidden',
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        padding: [Spacings.s12, Spacings.s16],
      },
    },
  },
  { name: 'header' }
);

export default useStyles;
